import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dConsole from "../Effect.Console/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCountries from "../Restaumatic.Countries/index.js";
import * as Restaumatic$dGeocoding$dTypes$dStreetAddress from "../Restaumatic.Geocoding.Types.StreetAddress/index.js";
import * as Restaumatic$dServices$dStorage from "../Restaumatic.Services.Storage/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const cachedGeocoding = v => next => {
  const $0 = v.key;
  const $1 = v.storage;
  return {
    geocodeAddress: country => address => Effect$dAff._bind(Effect$dAff._liftEffect(Restaumatic$dServices$dStorage.getJSONItem({
      decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
        reflectSymbol: () => "results"
      })(Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({reflectSymbol: () => "location"})((() => {
        const $2 = Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
          reflectSymbol: () => "longitude"
        })({decodeWithOptions: v$1 => Foreign.readNumber(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "latitude"})({
          decodeWithOptions: v$1 => Foreign.readNumber(Data$dIdentity.monadIdentity)
        })()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions));
        return {decodeWithOptions: v$1 => $2};
      })())()))())({reflectSymbol: () => "country"})({decodeWithOptions: v$1 => Restaumatic$dCountries.decodeCountry.decode})())({reflectSymbol: () => "address"})({
        decodeWithOptions: v$1 => Restaumatic$dGeocoding$dTypes$dStreetAddress.decodeStreetAddress.decode
      })()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
    })($1)($0)))(v1 => {
      const $2 = () => Effect$dAff._bind(Effect$dAff._liftEffect(Effect$dConsole.log("Geocoding: Cached result not found for " + Restaumatic$dCountries.showCountry.show(country) + " " + Restaumatic$dGeocoding$dTypes$dStreetAddress.showStreetAddress.show(address))))(() => Effect$dAff._bind(next.geocodeAddress(country)(address))(response => {
        if (response.tag === "Right") {
          const $2 = response._1;
          return Effect$dAff._bind(Effect$dAff._liftEffect($1._2($0)(Foreign$dInternal$dStringify.unsafeStringify(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
            reflectSymbol: () => "results"
          })((() => {
            const $3 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "location"})((() => {
              const $3 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
                reflectSymbol: () => "longitude"
              })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "latitude"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions);
              return {
                encodeWithOptions: v$1 => v2 => {
                  if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
                  if (v2.tag === "Just") { return $3(v2._1); }
                  $runtime.fail();
                }
              };
            })());
            return {encodeWithOptions: opts => $3.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)};
          })()))({reflectSymbol: () => "country"})({encodeWithOptions: v$1 => Restaumatic$dCountries.encodeCountry.encode}))({reflectSymbol: () => "address"})({
            encodeWithOptions: v$1 => Restaumatic$dGeocoding$dTypes$dStreetAddress.encodeStreetAddress.encode
          }).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)({address, country, results: $2})))))(() => Effect$dAff._pure(Data$dEither.$Either(
            "Right",
            $2
          )));
        }
        return Effect$dAff._pure(response);
      }));
      if (v1.tag === "Just") {
        if (
          v1._1.address.city === address.city && v1._1.address.street === address.street && v1._1.address.streetNumber === address.streetNumber && (() => {
            if (v1._1.country.tag === "PL") { return country.tag === "PL"; }
            if (v1._1.country.tag === "GB") { return country.tag === "GB"; }
            if (v1._1.country.tag === "RU") { return country.tag === "RU"; }
            if (v1._1.country.tag === "RO") { return country.tag === "RO"; }
            if (v1._1.country.tag === "CZ") { return country.tag === "CZ"; }
            if (v1._1.country.tag === "HR") { return country.tag === "HR"; }
            if (v1._1.country.tag === "SK") { return country.tag === "SK"; }
            if (v1._1.country.tag === "DE") { return country.tag === "DE"; }
            if (v1._1.country.tag === "NL") { return country.tag === "NL"; }
            if (v1._1.country.tag === "ES") { return country.tag === "ES"; }
            if (v1._1.country.tag === "BR") { return country.tag === "BR"; }
            if (v1._1.country.tag === "IT") { return country.tag === "IT"; }
            if (v1._1.country.tag === "SI") { return country.tag === "SI"; }
            return false;
          })()
        ) {
          const $3 = v1._1;
          return Effect$dAff._bind(Effect$dAff._liftEffect(Effect$dConsole.log("Geocoding: Using cached result for " + Restaumatic$dCountries.showCountry.show(country) + " " + Restaumatic$dGeocoding$dTypes$dStreetAddress.showStreetAddress.show(address))))(() => Effect$dAff._pure(Data$dEither.$Either(
            "Right",
            $3.results
          )));
        }
        return $2();
      }
      return $2();
    })
  };
};
export {cachedGeocoding};
